import { z } from 'zod';
/** The action target type of a sentinel activity. */
export var SentinelActivityTargetType;
(function (SentinelActivityTargetType) {
    SentinelActivityTargetType["User"] = "User";
    SentinelActivityTargetType["App"] = "App";
})(SentinelActivityTargetType || (SentinelActivityTargetType = {}));
export const sentinelActivityTargetTypeGuard = z.nativeEnum(SentinelActivityTargetType);
/** The action type of a sentinel activity. */
export var SentinelActivityAction;
(function (SentinelActivityAction) {
    /**
     * The subject tries to pass a verification by inputting a password.
     *
     * For example, a user (subject) who inputted a password (action) to authenticate themselves
     * (target).
     */
    SentinelActivityAction["Password"] = "Password";
    /**
     * The subject tries to pass a verification by inputting a verification code.
     *
     * For example, a user (subject) who inputted a verification code (action) to authenticate
     * themselves (target).
     */
    SentinelActivityAction["VerificationCode"] = "VerificationCode";
    /**
     * The subject tries to pass a verification by inputting a one-time token.
     *
     * For example, a user (subject) who inputted a one-time token (action) to authenticate
     * themselves (target), e.g. Magic Link.
     */
    SentinelActivityAction["OneTimeToken"] = "OneTimeToken";
    /**
     * The subject tries to pass a TOTP MFA verification.
     */
    SentinelActivityAction["MfaTotp"] = "MfaTotp";
    /**
     * The subject tries to pass a WebAuthn MFA verification.
     */
    SentinelActivityAction["WebAuthn"] = "WebAuthn";
    /**
     * The subject tries to pass a backup code MFA verification.
     */
    SentinelActivityAction["MfaBackupCode"] = "MfaBackupCode";
    /**
     * A verification code is sent to the target (email/phone), e.g. sign-in,
     * register, forgot-password, or identifier-binding codes.
     *
     * Used by the message rate limit to throttle sends, distinct from the
     * failure-based lockout actions above.
     */
    SentinelActivityAction["VerificationCodeSend"] = "VerificationCodeSend";
    /**
     * A non-verification-code message is sent to the target (email/phone),
     * e.g. an organization invitation.
     *
     * Used by the message rate limit to throttle sends.
     */
    SentinelActivityAction["MessageSend"] = "MessageSend";
})(SentinelActivityAction || (SentinelActivityAction = {}));
export const sentinelActivityActionGuard = z.nativeEnum(SentinelActivityAction);
export const sentinelActivityPayloadGuard = z.record(z.unknown());
